import { postFormData } from '@/lib/api/client'
import type { ApiResponse } from '@/lib/api/types'

export type FileUploadCategory = 'RESUME' | 'COVER_LETTER' 

export interface FileUploadResponse {
  fileUrl: string
  publicId: string
}

export interface FileDeleteResponse {
  message: string
}

export class FileUploadService {

  async uploadFile(
    file: File,
    category: FileUploadCategory
  ): Promise<ApiResponse<FileUploadResponse>> {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileUploadCategory', category)

    return await postFormData<ApiResponse<FileUploadResponse>>(
      'utils/public/upload-file',
      formData
    )
  }
}

export const fileUploadService = new FileUploadService()

export default fileUploadService
